import React from 'react'
import { Trans } from '@lingui/react/macro'
import { graphql, usePaginationFragment } from 'react-relay'

import { XStack, YStack } from 'tamagui'

import { GuildList } from '@newComponents/Guild/GuildList'
import { H2 } from '@newComponents/Text'

import { GuildNetworkGuildsSection_guild$key } from './__generated__/GuildNetworkGuildsSection_guild.graphql'

export const GuildNetworkGuildsSection = ({
  guild,
}: {
  guild: GuildNetworkGuildsSection_guild$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildNetworkGuildsSection_guild on Guild
      @refetchable(queryName: "GuildNetworkGuildsSectionPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 12 }
        cursor: { type: "Cursor" }
      ) {
        guilds: rankedNetworkGuilds(
          membershipStatus: ACCEPTED
          first: $count
          after: $cursor
        ) @connection(key: "GuildNetworkGuildsSection_guild_guilds") {
          ...GuildList_guildsConnection

          edges {
            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.guilds.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack flex={1}>
        <H2><Trans>Guilds in Network</Trans></H2>
      </XStack>

      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={3}
        hasNext={hasNext}
        loadNext={loadNext}
        display='none'
        $gtLg={{ display: 'flex' }}
      />

      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={2}
        hasNext={hasNext}
        loadNext={loadNext}
        display='none'
        $gtSm={{ display: 'flex' }}
        $gtLg={{ display: 'none' }}
      />

      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={1}
        hasNext={hasNext}
        loadNext={loadNext}
        display='flex'
        $gtSm={{ display: 'none' }}
      />
    </YStack>
  )
}
